import React from "react";
import quote from '../../assets/quote.png'
import quote2 from '../../assets/quote2.png'

const Edu = () => {
  return (
    <>
  <div className="w-1/3" >
    <img src={quote} style={{width:'50px' }}/>
  </div>
<p style={{fontSize:'20px', marginTop:'20px'}}>Leadership is not about being in charge; it's about taking care of those in your charge.
Success comes when your vision empowers others to achieve greatness.</p>
<div className="w-1/3" >
<img src={quote2} style={{width:'50px', marginLeft:'350px'}}/>
</div>
</>
  );
};

export default Edu;
